module.exports = "/_next/static/images/Alexandru_Railean-4affe1fb4f520df0c3655dd770d0a900.webp";